module.exports = __webpack_public_path__ + "img/Eagle 1.48bb6339.svg";